import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { MenustateService } from '../../../services/shared/menustate.service';
import { AuthService } from '../../../services/shared/auth.service';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core'; // Import TranslateService
import { filter } from 'rxjs';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css',
})
export class SidebarComponent implements OnInit, OnChanges {
  @Input() isCollapsed: boolean = false;
  @Output() sidebarToggled = new EventEmitter<boolean>();

  searchQuery: string = '';
  menuItems: any = [];
  originMenuItems: any = [];
  userName: string = '';
  userRole: string = '';
  menuLists: any = [];

  constructor(
    private menuStateService: MenustateService,
    private authService: AuthService,
    private router: Router,
    public translate: TranslateService
  ) {}

  ngOnInit(): void {
    const userPermission = this.authService.getPermissionIds();
    console.log('user permission', userPermission)
    if (!userPermission) {
      this.router.navigate(['/login']);
      return;
    }

    // 1. Listen for API Data
    this.menuStateService.menuState$.subscribe((res) => {
      this.processMenuData(res, userPermission);
    });

    // 2. Listen for URL Changes (Handles API navigation/clicks)
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.syncSelectionWithRoute();
      }
    });

    // User Info...
    const userInfo = this.authService.getUserRoleAndUserName();
    if (userInfo) {
      this.userName = userInfo.userName;
      this.userRole = userInfo.userRole;
    } else {
      this.router.navigate(['/login']);
    }
  }

  private processMenuData(res: any[], userPermission: string[]): void {
  const currentUrl = this.router.url;

  this.menuItems = res
    .filter((item: any) => {
      // Always allow Dashboard (1) and Nominee (9)
      // if (item.id == 1 || item.id === 9 || item.id === 10) return true;
      // return item.subMenu && item.subMenu.some((sub: any) => 
      //   userPermission.includes(sub.permission)
      // );
      const specialIds = [1, 9, 10];

    // 2. Check if the parent itself is permitted (especially for IDs 6, 7, 8)
    // const isParentPermitted = userPermission.includes(item.permission);
    const isParentPermitted = item.permissionCheck
  ? item.permissionCheck(userPermission)
  : userPermission.includes(item.permission);

const hasPermittedSubMenu =
  item.subMenu?.some((sub: any) =>
    userPermission.includes(sub.permission)
  ) ?? false;
    // Logic: Show the item if the parent is allowed OR if it has allowed children
    return isParentPermitted || hasPermittedSubMenu;
    })
    .map((item: any) => {
      // Filter the sub-menus based on permissions
      if (item.subMenu && item.subMenu.length > 0) {
        item.subMenu = item.subMenu.filter((sub: any) => 
          userPermission.includes(sub.permission)
        );
      }

      // RESET states initially to prevent "double selection"
      item.isSelected = false;
      item.isOpen = false;
      if (item.subMenu) {
        item.subMenu.forEach((sub: any) => sub.isSelected = false);
      }

      return item;
    });

  // Now run the sync logic to find the active route
  this.syncSelectionWithRoute();

  // FINAL FAILSAFE: If after sync nothing is selected, force Dashboard
  const activeItem = this.menuItems.find((m: any) => m.isSelected || m.subMenu?.some((s: any) => s.isSelected));
  
  if (!activeItem) {
    const dashboard = this.menuItems.find((m: any) => m.id === 1);
    if (dashboard) {
      dashboard.isSelected = true;
      dashboard.isOpen = true;
    }
  }

  this.originMenuItems = JSON.parse(JSON.stringify(this.menuItems));
}

  // 4. Shared logic to highlight menu based on current URL
//   private syncSelectionWithRoute(): void {
//     if (!this.menuItems || this.menuItems.length === 0) return;

//     const currentUrl = this.router.url;
//     let matchFound = false;

//     // 1. Reset everything to unselected first
//     this.menuItems.forEach((menu: any) => {
//       menu.isSelected = false;
//       menu.isOpen = false;
//       if (menu.subMenu) {
//         menu.subMenu.forEach((sub: any) => sub.isSelected = false);
//       }
//     });

//     // 2. Attempt to match the URL to a menu item
//     this.menuItems.forEach((menu: any) => {
//       if (menu.subMenu && menu.subMenu.length > 0) {
//         menu.subMenu.forEach((sub: any) => {
//           if (sub.link) {
//             const link = sub.link.startsWith('/') ? sub.link : '/' + sub.link;
//             const url = currentUrl.startsWith('/') ? currentUrl : '/' + currentUrl;
            
//             if (url.startsWith(link) && link !== '/dashboard/dashboard' && link !== '/') {
//               // console.log(`Matched Submenu: ${sub.title}`);
//               sub.isSelected = true;
//               menu.isSelected = true; 
//               menu.isOpen = true; 
//               matchFound = true;
//             }
//           }
//         });
//       } else if (menu.link) {
//           const link = menu.link.startsWith('/') ? menu.link : '/' + menu.link;
//           const url = currentUrl.startsWith('/') ? currentUrl : '/' + currentUrl;
          
//           if (url.startsWith(link) && link !== '/dashboard/dashboard' && link !== '/') {
//             // console.log(`Matched Top-Level: ${menu.name}`);
//             menu.isSelected = true;
//             matchFound = true;
//           }
//       }
//     });

//     // 3. If no match found (meaning we are on an inner detail page), restore from localStorage
//     if (!matchFound) {
//       const savedStateRaw = localStorage.getItem('menuState');
//       if (savedStateRaw) {
//         const parsedState = JSON.parse(savedStateRaw);
        
//         this.menuItems.forEach((menu: any) => {
//           const savedMenu = parsedState.find((m: any) => m.name === menu.name);
//           if (savedMenu) {
//             menu.isSelected = savedMenu.isSelected;
//             menu.isOpen = savedMenu.isOpen;

//             if (menu.subMenu && savedMenu.subMenu) {
//               menu.subMenu.forEach((sub: any) => {
//                 const savedSub = savedMenu.subMenu.find((s: any) => s.title === sub.title);
//                 if (savedSub) {
//                   sub.isSelected = savedSub.isSelected;
//                 }
//               });
//             }
//           }
//         });
//       }
//     }

//   // 4. Save the final state to localStorage
//   localStorage.setItem('menuState', JSON.stringify(this.menuItems));
// }
  

private syncSelectionWithRoute(): void {
  if (!this.menuItems || this.menuItems.length === 0) return;

  const currentUrl = this.router.url;
  let matchFound = false;

  // 1. Reset all 3 levels
  this.menuItems.forEach((menu: any) => {
    menu.isSelected = false;
    menu.isOpen = false;
    menu.subMenu?.forEach((sub: any) => {
      sub.isSelected = false;
      sub.isOpen = false;
      sub.innerSubMenu?.forEach((inner: any) => inner.isSelected = false);
    });
  });

  // 2. Deep Match (Level 3 -> Level 2 -> Level 1)
  mainLoop: for (let menu of this.menuItems) {
    if (menu.subMenu && menu.subMenu.length > 0) {
      for (let sub of menu.subMenu) {
        // CHECK LEVEL 3
        if (sub.innerSubMenu && sub.innerSubMenu.length > 0) {
          for (let inner of sub.innerSubMenu) {
            if (this.isUrlMatch(currentUrl, inner.link)) {
              inner.isSelected = true;
              sub.isSelected = true;
              sub.isOpen = true;      
              menu.isSelected = true;
              menu.isOpen = true;     
              matchFound = true;
              break mainLoop; 
            }
          }
        }
        // CHECK LEVEL 2
        if (sub.link && this.isUrlMatch(currentUrl, sub.link)) {
          sub.isSelected = true;
          menu.isSelected = true;
          menu.isOpen = true;
          matchFound = true;
          break mainLoop;
        }
      }
    } 
    else if (menu.link && this.isUrlMatch(currentUrl, menu.link)) {
      menu.isSelected = true;
      matchFound = true;
      break mainLoop;
    }
  }

  // 3. Corrected Fallback call
  if (!matchFound) {
    const saved = localStorage.getItem('menuState');
    if (saved) {
      this.restoreMenuState(saved);
    }
  }

  // 4. Save state
  localStorage.setItem('menuState', JSON.stringify(this.menuItems));
}

// Fixed Restore function to handle the 3rd level
restoreMenuState(savedState: string) {
  try {
    const parsedState = JSON.parse(savedState);
    this.menuItems.forEach((menu: any) => {
      const savedMenu = parsedState.find((m: any) => m.name === menu.name);
      if (savedMenu) {
        menu.isSelected = savedMenu.isSelected;
        menu.isOpen = savedMenu.isOpen;

        if (menu.subMenu && savedMenu.subMenu) {
          menu.subMenu.forEach((sub: any) => {
            const savedSub = savedMenu.subMenu.find((s: any) => s.title === sub.title);
            if (savedSub) {
              sub.isSelected = savedSub.isSelected;
              sub.isOpen = savedSub.isOpen || false;

              // ADDED: Restore Level 3 selection
              if (sub.innerSubMenu && savedSub.innerSubMenu) {
                sub.innerSubMenu.forEach((inner: any) => {
                  const savedInner = savedSub.innerSubMenu.find((i: any) => i.title === inner.title);
                  if (savedInner) {
                    inner.isSelected = savedInner.isSelected;
                  }
                });
              }
            }
          });
        }
      }
    });
  } catch (e) {
    console.error("Failed to parse menu state", e);
  }
}

private isUrlMatch(currentUrl: string, targetLink: string): boolean {
  if (!targetLink) return false;
  const link = targetLink.startsWith('/') ? targetLink : '/' + targetLink;
  const url = currentUrl.startsWith('/') ? currentUrl : '/' + currentUrl;
  return url.startsWith(link) && link !== '/dashboard/dashboard' && link !== '/';
}

  // bindMenu(apiData: any[]) {
  //   this.menuItems = apiData.map((menu, index) => ({
  //     id: index + 1,
  //     name: menu.MenuName,
  //     icon: '',
  //     openIcon: '',
  //     link: '',
  //     groupId: menu.GroupId,
  //     isOpen: false,
  //     isSelected: false,
  //     subMenu: Array.isArray(menu.PermissionClaims)
  //       ? menu.PermissionClaims
  //           .filter( 
  //             (claim: any) => //No show below menu at the moment. API do not control it. 
  //           // Frontend control it at the moment.Later, that two menu will add in frontend.
  //               claim.ClaimValue !== 'Request.ServiceRequest.HomeVerification' &&
  //               claim.ClaimValue !== 'Request.ServiceRequest.HomeCashout'
  //           )
  //           .map((claim: any) => ({
  //             subMenuId: claim.ClaimValue,
  //             title: claim.PermissionValue,
  //             icon: '',
  //             isSelected: false,
  //             link: ''
  //           }))
  //       : []
  //   }));
  // }

  // assignLinks() {
  //   this.menuItems.forEach((menu: any) => {
  //     switch (menu.groupId) {
  //       case '1':
  //         menu.icon = 'fa-solid fa-table-columns';
  //         menu.openIcon = 'fa-solid fa-table-columns';
  //         menu.link = 'dashboard/dashboard';
  //       break;
  //       case '2':
  //         menu.icon = 'fa-solid fa-folder-closed';
  //         menu.openIcon = 'fa-solid fa-folder-open';
  //       break;
  //       case '3':
  //         menu.icon = 'fa-solid fa-person-cane fs-5';
  //         menu.openIcon = 'fa-solid fa-person-cane fs-5';
  //       break;
  //       case '4':
  //         menu.icon = 'fa-solid fa-user';
  //         menu.openIcon = 'fa-solid fa-user';
  //       break;
  //       case '5':
  //         menu.icon = 'fa-solid fa-user-tie';
  //         menu.openIcon = 'fa-solid fa-user-tie';
  //       break;
  //       case '6':
  //         menu.icon = 'fa-solid fa-paper-plane';
  //         menu.openIcon = 'fa-solid fa-paper-plane';
  //       break;
  //       case '7':
  //         menu.icon = 'fa-solid fa-user';
  //         menu.openIcon = 'fa-solid fa-user';
  //       break;
  //       case '8':
  //         menu.icon = 'fa-solid fa-money-bill';
  //         menu.openIcon = 'fa-solid fa-money-bill';
  //         menu.link = '/reports';
  //       break;
  //       case '9':
  //         menu.icon = 'fa-solid fa-money-bill';
  //         menu.openIcon = 'fa-solid fa-money-bill';
  //         menu.link = '/reports';
  //       break;
  //       case '10':
  //         menu.icon = 'fa-solid fa-user';
  //         menu.openIcon = 'fa-solid fa-user';
  //         menu.link = '/nomineeonly/nomineelist';
  //       break;
  //     }

  //     menu.subMenu.forEach((sub: any) => {
  //       switch (sub.subMenuId) {
  //         case "Dashboard":
  //           sub.link = '/dashboard';
  //           sub.icon = 'fa-regular fa-circle-user';
  //           break;
  //         case "Verification.Level1":
  //           sub.link = '/verification/paymeverificationlist';
  //           sub.icon = 'fa-regular fa-circle-user';
  //           break;
  //         case 'Verification.Level2':
  //           sub.link = '/verification/lv2verificationlist';
  //           sub.icon = 'fa-regular fa-circle-user';
  //           break;
  //         case 'Verification.PDLevel1':
  //           sub.link = '/verification/pdofficerl1verification';
  //           sub.icon = 'fa-regular fa-circle-user';
  //           break;
  //         case 'Verification.PDLevel2':
  //           sub.link = '/verification/pdofficerl2verification';
  //           sub.icon = 'fa-regular fa-circle-user';
  //           break;
  //         case 'Verification.RejectPayMeUser':
  //           sub.link = '/verification/rejectedpaymeuser';
  //           sub.icon = 'bi bi-person-slash fw-bolder fs-5';
  //           break;
  //         case 'Verification.RejectPension':
  //           sub.link = '/verification/rejectedpension';
  //           sub.icon = 'bi bi-person-slash fw-bolder fs-5';
  //           break;
  //         case 'Pensioner.PayMeUser':
  //           sub.link = '/pensionermanagement/paymeuser';
  //           sub.icon = 'fa-regular fa-user';
  //           break;
  //         case "Pensioner.PayMePension":
  //           sub.link = '/pensionermanagement/paymepensionlist';
  //           sub.icon = 'fa-regular fa-user';
  //           break;
  //         case "Pensioner.ImportedPension":
  //           sub.link = '/pensionermanagement/pensionerdatalist';
  //           sub.icon = 'fa-regular fa-user';
  //           break;
  //         case "Pensioner.ImportedBatchFile":
  //           sub.link = '/pensionermanagement/batchfilelist';
  //           sub.icon = 'fa-regular fa-file-excel';
  //           break;
  //         case "Employee.UserSetup":
  //           sub.link = '/fosmanagement/registerfos';
  //           sub.icon = 'fa-regular fa-user';
  //           break;
  //         case "Employee.RoleSetup":
  //           sub.link = '/fosmanagement/fosroles/list';
  //           sub.icon = 'fa-regular fa-user';
  //           break;
  //         case "Employee.UserList":
  //           sub.link = '/fosmanagement/fosagentlist';
  //           sub.icon = 'fa-regular fa-user';
  //           break;
  //         case "Request.NewRequest":
  //           sub.link = '/requestmanagement/createrequestsearch';
  //           sub.icon = 'fa-regular fa-user';
  //           break;
  //         case "Request.ChangeRequestApproval":
  //           sub.link = '/requestmanagement/changerequestlist';
  //           sub.icon = 'fa-regular fa-user';
  //           break;
  //         case "Request.ServiceRequest.HomeEnrollment":
  //           sub.link = '/requestmanagement/servicerequestlist';
  //           sub.icon = 'fa-regular fa-user';
  //           break;
  //         case "FOSAgent.Level1":
  //           sub.link = '/agentmanagement/onboarding';
  //           sub.icon = 'fa-regular fa-user';
  //         break;
  //         case "FOSAgent.Level2":
  //           sub.link = '/agentmanagement/level2verification';
  //           sub.icon = 'fa-regular fa-user';
  //         break;
  //         case "FOSAgent.Level3":
  //           sub.link = '/agentmanagement/level3verification';
  //           sub.icon = 'fa-regular fa-user';
  //         break;
  //         case "FOSAgent.AgentList":
  //           sub.link = '/agentmanagement/agentlist';
  //           sub.icon = 'fa-regular fa-user';
  //         break;
  //         case "Admin.UserSetup":
  //           sub.link = '/admin/user/list';
  //           sub.icon = 'fa-regular fa-user';
  //         break;
  //         case "Admin.RoleSetup":
  //           sub.link = '/admin/role/list';
  //           sub.icon = 'bi bi-people';
  //         break;
  //         case "Admin.MinistrySetup":
  //           sub.link = '/admin/ministry/list';
  //           sub.icon = 'bi bi-buildings';
  //         break;
  //         case "Admin.DepartmentSetup":
  //           sub.link = '/admin/department/list';
  //           sub.icon = 'fa-regular fa-building';
  //         break;
  //         case "Admin.RegionSetup":
  //           sub.link = '/admin/region/list';
  //           sub.icon = 'bi bi-building-gear';
  //         break;
  //         case "Admin.CashCollectionPointSetup":
  //           sub.link = '/admin/cashcollectionpoints/list';
  //           sub.icon = 'bi bi-building-gear';
  //         break;
  //         // case "Transaction":
  //         //   sub.link = '/bod';
  //         //   sub.icon = 'bi bi-clock-history';
  //         //   break;
  //         // case "Nominee":
  //         //   sub.link = '/nomineeonly/nomineelist';
  //         //   sub.icon = 'fa-regular fa-user';
  //         // break;
  //         default:
  //           sub.link = '/reports'; // fallback
  //       }
  //     });
  //   });
  //   // this.originMenuItems = JSON.parse(JSON.stringify(this.menuItems));
  //   // console.log('originMenuItems', this.originMenuItems);
  //   // this.translateMenuItems();
  // }


  ngOnChanges(): void {
    this.translateMenuItems();
  }

  translateMenuItems() {
    this.menuItems = JSON.parse(
      JSON.stringify(
        this.originMenuItems.filter(
          (menu: any) =>
            this.translate
              .instant(menu.name)
              .toLowerCase()
              .includes(this.searchQuery.toLowerCase()) ||
            (menu.subMenu &&
              menu.subMenu.some((subMenu: any) =>
                this.translate
                  .instant(subMenu.title)
                  .toLowerCase()
                  .includes(this.searchQuery.toLowerCase())
              ))
        )
      )
    );
  }

 onSearchMenu(value: string) {

  this.searchQuery = value?.toLowerCase().trim() || '';

  // reset
  if (!this.searchQuery) {
    this.menuItems = JSON.parse(JSON.stringify(this.originMenuItems));
    return;
  }

  this.menuItems = this.originMenuItems
    .map((menu: any) => {

      // parent menu match
      const menuMatch =
        this.translate
          .instant(menu.name)
          .toLowerCase()
          .includes(this.searchQuery);

      // filter matching submenus
      const matchedSubMenus = menu.subMenu?.filter((subMenu: any) =>
        this.translate
          .instant(subMenu.title)
          .toLowerCase()
          .includes(this.searchQuery)
      ) || [];
       if (!this.searchQuery) {
        this.menuItems = JSON.parse(JSON.stringify(this.originMenuItems));
        return;
      }
      // keep menu if parent OR submenu matches
      if (menuMatch || matchedSubMenus.length > 0) {
        return {
          ...menu,
          isOpen: true,
          subMenu: menuMatch
            ? menu.subMenu
            : matchedSubMenus
        };
      }

      return null;
    })
    .filter(Boolean);
}

  toggleSubMenu(menuItem: any) {
    this.menuItems.forEach((menu: any) => {
      if (menu !== menuItem) {
        menu.isOpen = false;
        menu.isSelected = false;
      }
    });
    menuItem.isOpen = !menuItem.isOpen;
    menuItem.isSelected = !menuItem.isSelected;
    this.menuStateService.updateMenuState(this.menuItems);
  }

  trackByFn(index: number, item: any) {
    return item.Id;
  }

  trackByFnForSubMenu(index: number, item: any) {
    return item.link;
  }

  // selectSubMenu(subMenuItem: any, menu: any) {
  //   this.menuItems.forEach((menu: any) => {
  //     menu.isSelected = false;
  //     menu.subMenu.forEach((subMenu: any) => (subMenu.isSelected = false));
  //   });
  //   menu.isSelected = true;
  //   subMenuItem.isSelected = true;
  //   this.menuStateService.updateMenuState(this.menuItems);
  // }

  selectSubMenu(subMenuItem: any, menu: any) {

    // RESET ALL
    this.menuItems.forEach((menu: any) => {
      menu.isSelected = false;

      menu.subMenu.forEach((subMenu: any) => {
        subMenu.isSelected = false;

        // reset innerSubMenu
        if (subMenu.innerSubMenu) {
          subMenu.innerSubMenu.forEach((inner: any) => {
            inner.isSelected = false;
          });
        }
      });
    });

    // SELECT CURRENT MENU
    menu.isSelected = true;

    // CASE 1: clicked item is innerSubMenu
    if (subMenuItem?.link && menu.subMenu.some((s: any) =>
        s.innerSubMenu?.includes(subMenuItem))) {

      const parentSubMenu = menu.subMenu.find((s: any) =>
        s.innerSubMenu?.includes(subMenuItem));

      parentSubMenu.isSelected = true;
      parentSubMenu.isOpen = true;
      subMenuItem.isSelected = true;
    }

    // CASE 2: clicked item is normal subMenu
    else {
      subMenuItem.isSelected = true;
    }
    
    this.saveMenuState();

    this.menuStateService.updateMenuState(this.menuItems);
  }

  toggleInnerSubMenu(subMenu: any, event: Event) {
    event.stopPropagation();
    subMenu.isOpen = !subMenu.isOpen;
  }

  selectMenu(menu: any) {
    // Capture the current open state before resetting
    const wasOpen = menu.isOpen;

    // Reset ALL menus and submenus selection states
    this.menuItems.forEach((m: any) => {
      m.isSelected = false;
      // We only close other menus, not the one we clicked
      if (m !== menu) {
        m.isOpen = false;
      }

      if (m.subMenu) {
        m.subMenu.forEach((s: any) => {
          s.isSelected = false;
          if (s.innerSubMenu) {
            s.innerSubMenu.forEach((i: any) => i.isSelected = false);
          }
        });
      }
    });

    // Select clicked menu
    menu.isSelected = true;

    // Toggle behavior: If it was open, close it. If it was closed, open it.
    if (menu.subMenu && menu.subMenu.length > 0) {
      menu.isOpen = !wasOpen; 
    }

    this.saveMenuState();
  }


  handleMenuClick(menu: any) {
    this.selectMenu(menu);
    this.closeSidebarIfNeeded();
  }

  handleSubMenuClick(subMenu: any, menu: any) {
    this.selectSubMenu(subMenu, menu);
    this.closeSidebarIfNeeded();
  }

  closeSidebarIfNeeded() {
    if (window.innerWidth <= 768) {
      // Check if it's mobile view
      this.toggleSidebar();
    }
  }
  toggleSidebar() {
    // this.menuStateService.toggleSidebar();
    // this.isCollapsed = !this.isCollapsed;
    // this.sidebarToggled.emit();

    this.sidebarToggled.emit(!this.isCollapsed); // Emit the new state
  }

  saveMenuState() {
    localStorage.setItem('menuState', JSON.stringify(this.menuItems));
  }
}
